import React, { useMemo } from 'react';
import AttributesDialog from '../index';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useFocusedAttribute } from '../hooks/useFocusedAttribute';
import { Modes } from '../../../redux/reducers/focusedAttributeReducer';
import ActionButton from './EditSubmit';

const EditAttributeDialog = () => {
  const { attribute, handleClose } = useFocusedAttribute(Modes.EDIT);

  const { brands } = useSelector((state: RootStateOrAny) => state.UserReducer);

  const lockedFields = useMemo(
    () => ({
      name: true,
      isToggle: true,
      hasTrainingSystemAccess: !!attribute?.hasTrainingSystemAccess,
      isGeneralAttribute: !!attribute?.isGeneralAttribute,
    }),
    [attribute],
  );

  if (!attribute) return null;

  const brand = brands.find(({ brandCode }) => brandCode === attribute.brand);

  return (
    <AttributesDialog
      open
      onClose={handleClose}
      titleKey="attributes.modal.titleEdit"
      subtitleKey="attributes.modal.subtitleEdit"
      lockedFields={lockedFields}
      ActionButton={ActionButton}
      {...attribute}
      brand={brand}
    />
  );
};

export default EditAttributeDialog;
